// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay-module__overlay___DW+P8"};